export const UPLOAD_IMAGE_MAX_SIZE = 280

export const SUBJECT_MAX_LENGTH = 95

export const SUBJECT_WITH_CHINESE_MAX_LENGTH = 15

export const NO_DATA_ID = 0

export const MERGE_TAG_AMOUNT_LIMIT = 5
